// 全局自定义指令定义 李丁
import ifLogin from './ifLogin/ifLogin'

if (window.Vue) {
  window['Login'] = ifLogin
  Vue.use(install); // eslint-disable-line
}

export default {
  install(Vue) {
    Vue.directive('Login', ifLogin)
  }
}


